module.exports = __webpack_public_path__ + "img/american-express.009e4f80.png";